// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 2.868c0-.593.478-1.071 1.071-1.071H18.93c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H1.07A1.07 1.07 0 0 1 0 2.868m0 7.143C0 9.417.478 8.94 1.071 8.94H18.93c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H1.07A1.07 1.07 0 0 1 0 10.01m20 7.143c0 .594-.478 1.071-1.071 1.071H1.07A1.07 1.07 0 0 1 0 17.154c0-.594.478-1.071 1.071-1.071H18.93c.593 0 1.071.477 1.071 1.071"
  }));
};
